(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-phase-attrs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-phase')) {
    class TlPhase extends HTMLElement {
      connectedCallback() { this.update(); }

      disconnectedCallback() {
        clearTimeout(this.switchTimer);
        clearInterval(this.tickTimer);
      }

      update() {
        const now = Date.now() / 1000;
        const start = parseFloat(this.dataset.start) || 0;
        const end = parseFloat(this.dataset.end) || 0;
        let phase = 'live';
        if (start && now < start) phase = 'before';
        else if (end && now >= end) phase = 'after';

        if (this.dataset.phase !== phase) {
          this.dataset.phase = phase;
          this.dispatchEvent(new CustomEvent('tl:phase', { bubbles: true, detail: phase }));
        }

        for (const link of this.querySelectorAll('[data-href-' + phase + ']')) {
          link.setAttribute('href', link.getAttribute('data-href-' + phase));
        }

        clearTimeout(this.switchTimer);
        const next = phase === 'before' ? start : phase === 'live' ? end : 0;
        if (next) {
          const ms = (next - now) * 1000 + 300;
          if (ms < 2147483000) this.switchTimer = setTimeout(() => this.update(), ms);
        }

        clearInterval(this.tickTimer);
        if (phase !== 'after' && this.querySelector('[data-countdown]')) {
          this.tick();
          this.tickTimer = setInterval(() => this.tick(), 1000);
        }
      }

      tick() {
        const now = Date.now() / 1000;
        const pad = (n) => String(n).padStart(2, '0');
        for (const el of this.querySelectorAll('[data-countdown]')) {
          const target = parseFloat(el.dataset.countdown === 'start' ? this.dataset.start : this.dataset.end) || 0;
          let rest = Math.max(0, Math.floor(target - now));
          const parts = { d: Math.floor(rest / 86400), h: Math.floor((rest % 86400) / 3600), m: Math.floor((rest % 3600) / 60), s: rest % 60 };
          for (const key of Object.keys(parts)) {
            const node = el.querySelector('[data-' + key + ']');
            if (node) node.textContent = pad(parts[key]);
          }
        }
      }
    }
    customElements.define('tl-phase', TlPhase);
  }
  } catch(e) { console.error(e); }
})();

})();
